// (c) TwistedMinds, Gerry Uytdenhouwen - 1 november 2026

/**
 * True when the `account/last-order` response is an actual order of this widget.
 * The endpoint returns `[]` when there is none; an error (e.g. 401) returns `{message}`.
 */
export const isLastOrder = (response) =>
    Boolean(response) && !Array.isArray(response) && 'shop_mode' in response;
